import Input from 'src/components/forms/input';
import { isSiteCanadian } from '../../../../utils/helpers';
import React from 'react';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useLocalization } from 'src/utils/useLocalization';
import './style.scss';

export interface IApplicantPersonalInfo {
    values: any;
    errors: any;
    touched: any;
    handleChange: any;
    handleBlur: any;
    submitErrors: any;
}

const isCanada = isSiteCanadian();
const NAME_REGEX = /^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]*$/;

const ApplicantPersonalInfo: React.FC<IApplicantPersonalInfo> = ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    submitErrors,
}) => {
    const { applicantInfo } = useLocalization();
    const { markCreditFormTouched } = useCreditForm();

    let ssnLabel = '';

    const getCountryBasedParams = (isCanada: boolean) => {
        if (isCanada) {
            ssnLabel = applicantInfo.IDNUMBER_CA_LABEL;
        } else {
            ssnLabel = applicantInfo.IDNUMBER_US_LABEL;
        }
    };

    const handleInputChange = (e: any) => {
        markCreditFormTouched();
        handleChange(e);
    };

    getCountryBasedParams(isCanada);

    return (
        <>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <div className='c-form-field'>
                            <div className='c-form-field__box'>
                                <div className='c-input'>
                                    <Input
                                        labelName={
                                            applicantInfo.FIRSTNAME_LABEL
                                        }
                                        type={'text'}
                                        name={'firstName'}
                                        handlerChange={(e: any) => {
                                            if (
                                                NAME_REGEX.test(e.target.value)
                                            ) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        handlerBlur={handleBlur}
                                        value={values.firstName}
                                        asErrors={errors.firstName}
                                        asTouched={touched.firstName}
                                        asSubmitError={submitErrors.firstName}
                                        maxlength={30}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <div className='c-form-field'>
                            <div className='c-form-field__box'>
                                <div className='c-input'>
                                    <Input
                                        labelName={applicantInfo.MI_LABEL}
                                        type={'text'}
                                        name={'middleInitial'}
                                        maxlength={1}
                                        handlerChange={(e: any) => {
                                            if (
                                                NAME_REGEX.test(e.target.value)
                                            ) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        handlerBlur={handleBlur}
                                        value={values.middleInitial}
                                        asErrors={errors.middleInitial}
                                        asTouched={touched.middleInitial}
                                        asSubmitError={
                                            submitErrors.middleInitial
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <div className='c-form-field'>
                            <div className='c-form-field__box'>
                                <div className='c-input'>
                                    <Input
                                        labelName={applicantInfo.LASTNAME_LABEL}
                                        type={'text'}
                                        name={'lastName'}
                                        handlerChange={(e: any) => {
                                            if (
                                                NAME_REGEX.test(e.target.value)
                                            ) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        handlerBlur={handleBlur}
                                        value={values.lastName}
                                        asErrors={errors.lastName}
                                        asTouched={touched.lastName}
                                        asSubmitError={submitErrors.lastName}
                                        maxlength={30}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/2  u-1/1@xs'>
                        <div className='c-form-field'>
                            <div className='c-form-field__box'>
                                <div className='c-input'>
                                    <Input
                                        labelName={ssnLabel}
                                        type={'text'}
                                        name={'identificationNumber'}
                                        handlerChange={(e: any) => {
                                            const reg = /^[0-9-]*$/;
                                            if (
                                                e.target.value === '' ||
                                                reg.test(e.target.value)
                                            )
                                                handleInputChange(e);
                                        }}
                                        handlerBlur={handleBlur}
                                        value={values.identificationNumber}
                                        asErrors={errors.identificationNumber}
                                        asTouched={touched.identificationNumber}
                                        asSubmitError={
                                            submitErrors.identificationNumber
                                        }
                                        maxlength={11}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='o-layout__item  u-1/2  u-1/1@xs'>
                        <div className='c-form-field'>
                            <div className='c-form-field__box'>
                                <div className='c-input'>
                                    <Input
                                        labelName={
                                            applicantInfo.BIRTHDATE_LABEL
                                        }
                                        type={'text'}
                                        name={'dateOfBirth'}
                                        handlerChange={handleInputChange}
                                        handlerBlur={handleBlur}
                                        value={values.dateOfBirth}
                                        asErrors={errors.dateOfBirth}
                                        asTouched={touched.dateOfBirth}
                                        asSubmitError={submitErrors.dateOfBirth}
                                        maxlength={Number('10')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ApplicantPersonalInfo;
